import { BlocksCard } from 'blocks-nextjs/blocks-web-components/components/card/card';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatCard = createComponent({ react: React, tagName: 'cat-card', elementClass: BlocksCard });
